import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { IconAlertTriangle } from "@tabler/icons-react";

const ModalLogoutPage = ({ visible, onClose }) => {
  const navigate = useNavigate();
  // Evita scroll del body cuando el modal está abierto
  useEffect(() => {
    if (visible) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
  }, [visible]);

  if (!visible) return null;

  return (
    <>
      <div className="modal modal-blur fade show d-block" tabIndex="-1" role="dialog">
        <div className="modal-dialog modal-sm modal-dialog-centered" role="document" style={{ zIndex: 1055 }}>
          <div className="modal-content">
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            <div className="modal-status bg-danger"></div>
            <div className="modal-body text-center py-4">
              <IconAlertTriangle className="icon mb-2 text-danger icon-lg" />
              <h3>Cerrar Sesión</h3>
              <div className="text-secondary">¿Estás seguro que deseas cerrar tu sesión?</div>
            </div>
            <div className="modal-footer">
              <div className="w-100">
                <div className="row">
                  <div className="col">
                    <button type="button" className="btn btn-3 w-100" onClick={onClose}>
                      Cancelar
                    </button>
                  </div>
                  <div className="col">
                    <button type="button" onClick={() => navigate("/Logout")} className="btn btn-danger btn-4 w-100">
                      Si, cerrar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
};

export default ModalLogoutPage;
